<template>
  <div class="row">
    <div class="col-4">
      <p>Use this VIN Search facility to look for a vehicle within the OPUS IVS partner network using ADAS Map.</p>
      <!-- VIN Search tool -->
      <div class="input-group custom-vin-search">
        <input
          v-model="vin"
          class="form-control custom-vin-input"
          type="text"
          maxlength="17"
          placeholder="enter or paste VIN # here"
          @keyup="vinKeyupHandler"
        />
        <span class="input-group-text custom-clear" title="clear VIN" @click="clearVINSearch">
          <i class="fas fa-times"></i>
        </span>
        <button class="btn btn-primary btn-sm" :disabled="isLoading" @click="searchVIN">
          <FontAwesomeIcon v-if="isLoading" icon="fa-solid fa-spinner" spin />
          <FontAwesomeIcon v-else icon="fa-solid fa-search" />
          <span class="ms-2">Search</span>
        </button>
      </div>
    </div>
  </div>
  <div class="row mt-2">
    <div class="col">
      <!-- VIN Search Results -->
      <z-table
        v-model="vinSearchResults"
        class="table table-bordered table-striped"
        :is-single-row-detail="false"
        :is-header-fixed="isHeaderFixed"
        :columns="tableColumnsName"
        :loading="isLoading"
      >
        <template #tbody="props">
          <td>{{ props.row.source }}</td>
          <td>{{ props.row.firmName }}</td>
          <td>{{ formatVehicle(props.row) }}</td>
          <td>{{ props.row.vin }}</td>
          <td>{{ props.row.firm }}</td>
          <td>{{ props.row.adas }}</td>
          <td>{{ props.row.repair }}</td>
          <td>{{ props.row.vehicle }}</td>
        </template>
        <template #empty> Nothing found! </template>
      </z-table>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { dataStore } from '@/stores/data'
import ZTable from '@/components/utilities/elements/Table.vue'
export default {
  name: 'FindVin',
  components: {
    ZTable
  },
  data() {
    return {
      vin: null
    }
  },
  computed: {
    ...mapState(dataStore, ['loading', 'vinSearchResults']),
    isLoading() {
      let _is = false
      if (this.loading) {
        if (this.loading.vinSearchResults) {
          _is = this.loading.vinSearchResults
        }
      }
      return _is
    },
    tableColumnsName() {
      let columns = [
        {
          field: 'source',
          label: 'Source',
          sortable: false
        },
        {
          field: 'firmName',
          label: 'Location',
          sortable: false
        },
        {
          field: 'vehicle',
          label: 'Vehicle',
          sortable: false
        },
        {
          field: 'vin',
          label: 'VIN',
          sortable: false
        },
        {
          field: 'firm',
          label: 'Firm Id',
          sortable: false
        },
        {
          field: 'adas',
          label: 'ADAS Id',
          sortable: false
        },
        {
          field: 'repair',
          label: 'Repair Id',
          sortable: false
        },
        {
          field: 'vehicle',
          label: 'Vehicle Id',
          sortable: false
        }
      ]
      return columns
    }
  },
  methods: {
    ...mapActions(dataStore, ['searchByVin']),
    vinKeyupHandler() {
      console.log('VIN Keyup')
    },
    clearVINSearch() {
      this.isSearching = false
      this.isFinished = false
      this.vin = null
      this.resetVinSearch()
      console.log('Clear VIN Search')
    },
    async searchVIN() {
      console.log('Search VIN', this.vin)
      if (this.vin) {
        if (this.vin.trim() !== '') {
          await this.searchByVin(this.vin)
        }
      }
    },
    formatVehicle(row) {
      return `${row.year} ${row.makeName} ${row.model}`
    },
    gotoLocation(row) {
      console.log('Goto Location', row)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-search-result {
  display: flex;
  flex-direction: column;
}
.custom-vehicle {
  font-size: 1.1rem;
  font-weight: 400;
}
.custom-count {
  font-size: 0.9rem;
  font-weight: 400;
}
.custom-vin-search {
  margin-top: 15px;
  border: 2px solid #ff0000;
  padding: 15px;
}
.custom-vin-input {
  font-size: 1.3rem !important;
  font-weight: 600 !important;
}
</style>
